// helper
import { styleGenerator } from '../../helper';

// constants
import { IMAX_WIDTH, GL_GAP, G_TYPO, N_TYPO, G_MARGIN, F_BG, B_BG, G_RADIUS, FG_RADIUS } from './constants';

/**
 * Internal dependencies
 */
const {
    // generateAlignmentStyles,
    // generateBorderStyles,
    generateResBoxStyles,
    generateBgStyles,
    generateRangeStyles,
    generateTypographyStyles,
    // generateResBtnsGroupStyle,
    GlobalStyleHandler
} = window.progressmatifyModules;

// Generate Dynamic Style
const DynamicStyle = props => {
    const { attributes, setAttributes } = props;
    const { uniqueId, textColor, numberColor } = attributes;

    // global section
    const {
        deskStyle: iDeskMaxWidth,
        tabStyle: iTabMaxWidth,
        mobStyle: iMobMaxWidth
    } = generateRangeStyles({
        controlName: IMAX_WIDTH,
        attributes,
        propertyName: 'max-width'
    });
    const {
        deskStyle: gDeskGap,
        tabStyle: gTabGap,
        mobStyle: gMobGap
    } = generateRangeStyles({
        controlName: GL_GAP,
        attributes,
        propertyName: 'height'
    });
    const {
        desktopStyles: gDeskTypo,
        tabletStyles: gTabTypo,
        mobileStyles: gMobTypo
    } = generateTypographyStyles({
        controlName: G_TYPO,
        attributes
    });
    const {
        desktopStyles: nDeskTypo,
        tabletStyles: nTabTypo,
        mobileStyles: nMobTypo
    } = generateTypographyStyles({
        controlName: N_TYPO,
        attributes
    });
    const {
        boxDeskStyles: gDeskMargin,
        boxTabStyles: gTabMargin,
        boxMobStyles: gMobMargin
    } = generateResBoxStyles({
        controlName: G_MARGIN,
        attributes,
        propertyName: 'margin',
        forRadius: false
    });
    const { bgStyle: fBg } = generateBgStyles({
        controlName: F_BG,
        attributes
    });
    const { bgStyle: bBg } = generateBgStyles({
        controlName: B_BG,
        attributes
    });
    const {
        boxDeskStyles: gDeskBRadius,
        boxTabStyles: gTabBRadius,
        boxMobStyles: gMobBRadius
    } = generateResBoxStyles({
        controlName: G_RADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });
    const {
        boxDeskStyles: fgDeskBRadius,
        boxTabStyles: fgTabBRadius,
        boxMobStyles: fgMobBRadius
    } = generateResBoxStyles({
        controlName: FG_RADIUS,
        attributes,
        propertyName: 'border-radius',
        forRadius: true
    });
    // Desktop Styles
    const deskStyles = `
         ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-item`, [
             {
                 v: iDeskMaxWidth
             },
             {
                 v: gDeskGap
             },
             {
                 v: gDeskMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title`, [
              {
                  v: gDeskTypo
              },
              {
                  p: 'color',
                  v: textColor
              }
          ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent`, [
               {
                   v: nDeskTypo
               },
               {
                   p: 'color',
                   v: numberColor
               }
           ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
               {
                   v: fBg
               },
               {
                   v: fgDeskBRadius
               }
           ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: bBg
               },
               {
                   v: gDeskBRadius
               }
           ])}
    `;
    const tabStyles = `
         ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-item`, [
             {
                 v: iTabMaxWidth
             },
             {
                 v: gTabGap
             },
             {
                 v: gTabMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title`, [
              {
                  v: gTabTypo
              }
          ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent`, [
               {
                   v: nTabTypo
               }
           ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: gTabBRadius
               }
           ])}
            ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
                {
                    v: fgTabBRadius
                }
            ])}
    `;
    const mobStyles = `
         ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-item`, [
             {
                 v: iMobMaxWidth
             },
             {
                 v: gMobGap
             },
             {
                 v: gMobMargin
             }
         ])}
          ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-title`, [
              {
                  v: gMobTypo
              }
          ])}
           ${styleGenerator(`.${uniqueId} .gbk-pdReview-bar-percent`, [
               {
                   v: nMobTypo
               }
           ])}
           ${styleGenerator(`.${uniqueId} .progressmatify-bar`, [
               {
                   v: gMobBRadius
               }
           ])}
            ${styleGenerator(`.${uniqueId} .progressmatify-bar-fill`, [
                {
                    v: fgMobBRadius
                }
            ])}
    `;

    return (
        <GlobalStyleHandler
            attributes={attributes}
            setAttributes={setAttributes}
            deskStyles={deskStyles}
            tabStyles={tabStyles}
            mobStyles={mobStyles}
        />
    );
};

export default DynamicStyle;
